import useComputed from '@/hooks/use-computed'
import api from '@/services/api/role.js'
import { immerable } from "immer"
import { useState } from 'react'

class Role {

	[immerable] = true

	constructor(params) {
		this.created = params.created
		this.createdBy = params.createdBy
		this.id = params.id
		this.modified = params.modified
		this.modifiedBy = params.modifiedBy
		this.label = params.name
		this.organizationId = params.organizationId
		this.permission = params.permission
		this.$selected = false
	}
}

const useRole = () => {

	const [itemsRole, setItemsRole] = useComputed([])
	const [loadingRole, setLoadingRole] = useState(false)
	const [errorRole, setErrorRole] = useState()

	async function fetchRole(organizationId) {
		setLoadingRole(true);

		let params = {}

		if (organizationId) {
			params = { organizationId: organizationId }
		}

		const [error, response] = await api.index({params})

		setLoadingRole(false)

		if (error) {
			return setErrorRole(error)
		}

		if (!Array.isArray(response)) {
			return setErrorRole('Roles is not an array')
		}

		const serializedData = response.map(entry => serialize(entry))
		const newItems = serializedData.map(parameter => new Role(parameter))

		setItemsRole(newItems);
	}

	function serialize(entry) {
		return {
			created: entry.created,
			createdBy: entry.createdBy,
			id: entry.id,
			modified: entry.modified,
			modifiedBy: entry.modifiedBy,
			name: entry.name,
			organizationId: entry.organizationId,
			permission: entry.permission
		}
	}

	return {
		errorRole,
		fetchRole,
		itemsRole,
		setItemsRole,
		loadingRole
	}

}

export default useRole;
